import { FormEvent } from 'react';
import { useFormContext } from 'react-hook-form';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useTranslation } from 'next-i18next';
import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogOverlay, DialogPanel, DialogTitle, Input, TextField } from '@zep/ui';
import { useUpdateZipCode } from '../../../../services';
import { PlanCheckoutFormSchemaType } from '../subscriptionPayment';
import { AdditionalPaymentFormProvider } from './AdditionalPaymentFormProvider';
const ZipCodeModalContent = (props: RegisterZipCodeModalProps) => {
  const {
    visible,
    remove,
    hide
  } = useModal();
  const {
    t
  } = useTranslation(['subscription']);
  return <Dialog maxWidth="320px" open={visible} onClose={() => null} afterClose={remove} drawer data-sentry-element="Dialog" data-sentry-component="ZipCodeModalContent" data-sentry-source-file="ZipCodeInputModal.tsx">
      <DialogOverlay data-sentry-element="DialogOverlay" data-sentry-source-file="ZipCodeInputModal.tsx" />
      <AdditionalPaymentFormProvider zipCode={props.zipCode} data-sentry-element="AdditionalPaymentFormProvider" data-sentry-source-file="ZipCodeInputModal.tsx">
        <DialogPanel data-sentry-element="DialogPanel" data-sentry-source-file="ZipCodeInputModal.tsx">
          <DialogHeader onClose={hide} data-sentry-element="DialogHeader" data-sentry-source-file="ZipCodeInputModal.tsx">
            <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="ZipCodeInputModal.tsx">
              {t('subscription:SpaceDetail.zipCode.changeText')}
            </DialogTitle>
          </DialogHeader>
          <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="ZipCodeInputModal.tsx">
            <Content data-sentry-element="Content" data-sentry-source-file="ZipCodeInputModal.tsx" />
          </DialogContent>
          <DialogFooter data-sentry-element="DialogFooter" data-sentry-source-file="ZipCodeInputModal.tsx">
            <Action {...props} data-sentry-element="Action" data-sentry-source-file="ZipCodeInputModal.tsx" />
          </DialogFooter>
        </DialogPanel>
      </AdditionalPaymentFormProvider>
    </Dialog>;
};
const Content = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    formState: {
      errors
    },
    register,
    setValue
  } = useFormContext<PlanCheckoutFormSchemaType>();
  const {
    ref,
    onChange,
    name
  } = register('zipCode');
  const validateZipCodeInput = (event: FormEvent<HTMLInputElement>) => {
    const value = (event.target as HTMLInputElement).value.replace(/[^0-9]/g, '');
    setValue('zipCode', value);
  };
  return <>
      <TextField description={t('subscription:invoice.zipCode.description')} error={!!errors?.zipCode?.message} helperText={t(errors?.zipCode?.message as 'subscription:payment.zipCode.minErrorText')} data-sentry-element="TextField" data-sentry-source-file="ZipCodeInputModal.tsx">
        <Input name={name} ref={ref} onChange={onChange} size={'sm'} type="text" maxLength={10} onInput={validateZipCodeInput} placeholder={t('subscription:payment.zipCode.placeholder')} isFullWidth error={!!errors?.zipCode?.message} data-sentry-element="Input" data-sentry-source-file="ZipCodeInputModal.tsx" />
      </TextField>
    </>;
};
const Action = ({
  spaceHashId,
  onSuccess,
  onError
}: Omit<RegisterZipCodeModalProps, 'zipCode'>) => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    mutateAsync: mutateZipCode
  } = useUpdateZipCode();
  const {
    formState: {
      errors,
      isDirty
    },
    getValues
  } = useFormContext<PlanCheckoutFormSchemaType>();
  const handleClickZipCode = async () => {
    try {
      await mutateZipCode({
        spaceHashId,
        zipCode: getValues('zipCode') || ''
      });
      onSuccess();
    } catch (error) {
      onError(error as {
        status: number;
        statusKey: string;
        data: null;
      });
    }
  };
  return <Button type="button" disabled={!!Object.keys(errors).length || !isDirty} onClick={handleClickZipCode} isFullWidth data-sentry-element="Button" data-sentry-component="Action" data-sentry-source-file="ZipCodeInputModal.tsx">
      {t('subscription:paymentPayple.AlertFailPay.buttonConfirm')}
    </Button>;
};
export const RegisterZipCodeModal = NiceModal.create(ZipCodeModalContent);
export type RegisterZipCodeModalProps = {
  spaceHashId: string;
  zipCode: string;
  onSuccess: () => void;
  onError: (error: {
    status: number;
    statusKey: string;
    data: null;
  }) => void;
};